import { render, staticRenderFns } from "./Primes.vue?vue&type=template&id=afeeb004&"
import script from "./Primes.vue?vue&type=script&lang=js&"
export * from "./Primes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports